export default __webpack_public_path__ + "static/media/Tiger's Helm of the Savage Sun.d3b9441a.jpg";